// extracted by mini-css-extract-plugin
export var fadeInOut = "_2x-3";
export var icon = "_2x-4";
export var savedIndicator = "_2x-2";
export var savingIndicator = "_2x-0";
export var spin = "_2x-1";